module.exports = __webpack_public_path__ + "static/media/cart.ed4092e2.svg";